<template>
  <el-dropdown trigger="click" @command="handleCommand">
    <el-button type="info" plain>доп. меню</el-button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="m in menu" :key="m.text" :command="m.command">
        {{ m.text }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { contactMenu, taskMenu } from '@/views/CallCenter/constants'

export default {
  name: 'AdditionalMenu',
  props: {
    tasks: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menu: this.tasks ? taskMenu : contactMenu,
    }
  },
  methods: {
    handleCommand(func) {
      this[func]()
    },
    addItem() {
      this.$emit('add')
    },
    goToTasks() {
      this.$router.push('/call-center')
    },
    goToСontacts() {
      this.$router.push('/call-center/contacts')
    },
  },
}
</script>

<style lang="sass"></style>
